/**
 * 匠人 接口的统一出口
 */
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块，把请求字段直接映射过来

const index = {
    // 匠人列表
    list(params) {
        return axios.get("/home/tradesman/list", { params: params });
    },
    // 匠人的商品列表
    goods(params) {
        return axios.get("/home/tradesman/goods", { params: params });
    },
    // 匠人约看
    lives(params) {
        return axios.get("/home/tradesman/lives", { params: params });
    },
    // 匠人介绍
    detail(params) {
        return axios.get("/home/tradesman/info", { params: params });
    },
    // 匠人资讯
    history(params) {
        return axios.get("/home/tradesman/infolist", { params: params });
    },
    // 关注/取消关注匠人
    attention(params) {
        return axios.post("/home/tradesman/attention", qs.stringify(params));
    },
    // 匠人信息
    info(params) {
        return axios.get("/home/tradesman/info", { params: params });
    },
    // 图集列表
    photo(params) {
        return axios.get("/home/tradthumb/list", { params: params });
    },
    // 图集详情
    photoDetail(params) {
        return axios.get("/home/tradthumb/detail", { params: params });
    },
    // 图集评论
    photoComment(params) {
        return axios.post("/home/tradthumb/addcomment", qs.stringify(params));
    },
    // 图集点赞
    photoLike(params) {
        return axios.post("/home/tradthumb/like", qs.stringify(params));
    },
    // 图集评论列表
    photoCommentList(params) {
        return axios.get("/home/tradthumb/comment", { params: params });
    },
    // 匠人查看图集列表
    thumbList(params) {
        return axios.get("/home/centertradthumb/list", { params: params });
    },
    // 匠人查看图集详情
    thumbDetail(params) {
        return axios.get("/home/centertradthumb/detail", { params: params });
    },
    // 匠人发布图集
    thumbAdd(params) {
        return axios.post("/home/tradthumb/add", qs.stringify(params));
    },
    // 匠人编辑图集
    thumbEdit(params) {
        return axios.post("/home/tradthumb/edit", qs.stringify(params));
    },
    // 匠人图集分类
    thumbCate(params) {
        return axios.get("/home/tradthumb/catelist", { params: params });
    },
    // 匠人收入列表
    income(params) {
        return axios.get("/home/trincome/data", { params: params });
    },
    // 商铺中心商品列表
    centerGoods(params) {
        return axios.get("/home/tradcenter/goods", { params: params });
    },
    // 下架商品
    drop(params) {
        return axios.post("/home/goods/drop", qs.stringify(params));
    },
    // 上架商品
    on(params) {
        return axios.post("/home/goods/on", qs.stringify(params));
    },
    // 获取商家二维码
    qrcode(params) {
        return axios.get("/home/trad/qrcode", { params: params });
    },
    // 店铺设置头像
    thumb(params) {
        return axios.post("/home/trad/thumb", qs.stringify(params));
    },
    // 设置邮费
    fare(params) {
        return axios.post("/home/trad/fare", qs.stringify(params));
    },
    // 匠人订单列表
    order(params) {
        return axios.post("/home/b2c/merorderlist", qs.stringify(params));
    },
    // 匠人技艺
    skill(params) {
        return axios.get("/home/tradesman/skill", { params: params });
    },
    // 匠人分类
    cate(params) {
        return axios.get("/home/tradesman/cate", { params: params });
    },
    // 拉取发票列表
    fapiaoList(params) {
        return axios.get("/home/saleInvoices/list", { params: params });
    },
    // 关闭订单
    closeOrder(params) {
        return axios.get("/home/b2c/merdelorder", { params: params });
    },
    // 查询匠人的代理商和城市合伙人
    getAgentsAndPartners(params) {
        return axios.get("/home/tradesman/getAgentsAndPartners", {
            params: params,
        });
    },
    // 园区类型
    getTradesmanPark(params) {
        return axios.get("/home/user/park", { params: params });
    },
    // 供应商详情
    sellerInfo(params) {
        return axios.get("/home/seller/info", { params: params });
    },
    // 快递列表
    kuaidiList(params) {
        return axios.get("/home/logistics/list", { params: params });
    },
    // 商家发货
    fahuo(params) {
        return axios.post("/home/b2c/mership", qs.stringify(params));
    },
    // 匠人修改定制
	updateDingzhi(params) {
		return axios.post('/home/custommade/editcustomizedcommunity', qs.stringify(params))
	},
	// 商家定制订单列表
	tradeorder(params){
		return axios.get("/home/custommade/tradeorder", { params: params });
	},
	// 商家定制订单,定制完成
	ordermake(params){
		return axios.post('/home/custommade/ordermake', qs.stringify(params))
	},
	// 商家定制订单,发货
	ordership(params){
		return axios.post('/home/custommade/ordership', qs.stringify(params))
	},
	// 匠人关联的项目
	item(params){
		return axios.get("/home/tradesman/item", { params: params });
	},
	// 获取匠人来源
	sorcelist(params){
		return axios.get("/home/tradesman/sorcelist", { params: params });
	},
	// 商户 推送商品到云平台
	pushGoods(params){
		return axios.post('/home/goods/tocloud', qs.stringify(params));
	},
	// 商户 推送定制到云平台
	pushMades(params){
		return axios.post('/home/mades/tocloud', qs.stringify(params));
	}
};

// 导出接口
export default index;
